import { Accordion, AccordionContext, Card } from 'react-bootstrap';
import { Answer } from '../../HelpCenter.types';
import './FAQComponentItem.scss';
import { useContext } from 'react';
const BlockContent = require('@sanity/block-content-to-react');

interface FAQComponentItemProps {
  accordionKey: string;
  question: string;
  answer: Answer[];
}

const AccordionTitle = ({ children, eventKey }: { children: string; eventKey?: any }) => {
  const currentEventKey = useContext(AccordionContext);
  return (
    <div className="faq-item">
      <div className={currentEventKey === eventKey ? 'highlighted' : ''}>{children}</div>
      {currentEventKey === eventKey ? (
        <i className="fa fa-chevron-up faq-item-icon" aria-hidden="true" />
      ) : (
        <i className="fa fa-chevron-down faq-item-icon" aria-hidden="true" />
      )}
    </div>
  );
};

function FAQComponentItem({ accordionKey, question, answer }: FAQComponentItemProps) {
  return (
    <Card className="faq-component-item">
      <Accordion.Toggle as={Card.Header} eventKey={accordionKey}>
        <AccordionTitle eventKey={accordionKey}>{question}</AccordionTitle>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={accordionKey}>
        <Card.Body>{answer.map(answer => <BlockContent blocks={answer}></BlockContent>)}</Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
export default FAQComponentItem;
